// extracted by mini-css-extract-plugin
export default {"m":"_9280f7d460","title":"d80ac48dc2","feedback_inner_title":"ce0a61248b","textarea":"_57ed7dbece","radio":"bfe736d734","text":"e646698c56"};